import { Component, EventEmitter, OnInit, Output, ViewContainerRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import moment from 'moment';
import { Subject } from 'rxjs';
import { MemoService } from 'src/app/services/memo/memo.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { RechercheMultiService } from 'src/app/services/recherche/recherche-multi.service';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { RechercheMultiCriteres } from 'src/app/utils/interfaces/new/recherche';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-recherche-multi',
  templateUrl: './recherche-multi-liste.fragment.html',
  styleUrls: ['./recherche-multi-liste.fragment.scss', '../modal.fragment.scss'],
})


export class RechercheMultiListeFragment implements OnInit {

  public header = '';
  public error = ''; 
  public refreshStream: Subject<any>;
  public isEdit = false;
  public professionColumnTable = [
    { title: 'Titre', data: 'titre' },
    { title: 'Création', data: 'dateCreation' },
    { title: 'Par', data: 'createur' },
    { title: 'Modification', data: 'dateModification' },
    { title: 'Par', data: 'modificateur' },
    { title: 'Activer/Désactiver', data: null },
    { title: 'Supprimer', data: null },
    { title: 'Charger', data: null },
  ];
  public displayedColumns: string[] = ['titre', 'dateCreation', 'createur', 'dateModification', 'modificateur', 'enable', 'select', 'delete'];
  public listRecherche: Paginated<RechercheMultiCriteres>;

  @Output() public closeEmitter = new EventEmitter();

  constructor(
    private formBuilder: FormBuilder,
    public viewContainerRef: ViewContainerRef,
    public modalService: ModalService,
    private memoService: MemoService,
    private rechercheSvc: RechercheMultiService,
    private _strUtilsSrv: StringUtilsService
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  async loadData() {
    this.listRecherche = await this.rechercheSvc.listRecherches();
    // Remettre à plat les utilisateurs
    if (this.listRecherche && this.listRecherche.objects) {
      for (let recherche of this.listRecherche.objects) {
        if (recherche.auteurCreation) {
          recherche.createur = recherche.auteurCreation.nom.toLocaleUpperCase() + " " + this._strUtilsSrv.uppercaseFirstCharString(recherche.auteurCreation.prenom);
        }
        if (recherche.auteurModification) {
          recherche.modificateur = recherche.auteurModification.nom.toLocaleUpperCase() + " " + this._strUtilsSrv.uppercaseFirstCharString(recherche.auteurModification.prenom);
        }
        (recherche as any).dateCreationDisplay = moment(recherche.dateCreation).format('DD/MM/YYYY');
        (recherche as any).dateModificationDisplay = moment(recherche.dateCreation).format('DD/MM/YYYY');;
        // if (recherche.enabled) {
        //   (recherche as any).isEnable = 'Activé';
        // } else {
        //   (recherche as any).isEnable = 'Désactivé';
        // }
      }
    }
  }

  public clickOuside(): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }
    this.closeRechercheModal();
  }

  public closeRechercheModal(): void {
    this.closeEmitter.emit(null);
  }

  public stopPropagation(event: any): void {
    event.stopPropagation();
  }

  public async deleteRecherche(event: any) {
    try {
      await this.rechercheSvc.deleteRecherche(event.id);
      this.loadData();
    } catch (error) {
      console.error(error);
      this.error = "Impossible de supprimer la recherche";
    }
  }

  public loadRecherche(event: any): void {
    this.refreshStream.next({ domain: "recherche", operation: "load", object: event });
    this.closeRechercheModal();
  }

  public disableRechercheFichePatient(event: any): void {
    this.refreshStream.next({ domain: "recherche", operation: "enable", object: event });
    this.closeRechercheModal();
  }
}
